var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6386_7841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.5906 17.1165L64.86 9.4182C54.4387 6.62582 46.7361 11.1019 43.9345 21.5575L34.446 56.9693C31.5985 67.5963 36.0679 75.1869 46.4891 77.9793L75.2197 85.6776C85.8089 88.515 93.3034 84.1301 96.1509 73.5031L105.639 38.0913C108.441 27.6357 104.18 19.9539 93.5906 17.1165Z",
    fill: "url(#paint0_linear_6386_7841)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_6386_7841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.0819 26.8137L66.5075 21.5688C59.4074 19.6663 54.1595 22.7159 52.2508 29.8394L45.7861 53.9658C43.8461 61.206 46.8911 66.3776 53.9913 68.2801L73.5656 73.525C80.7802 75.4581 85.8863 72.4707 87.8263 65.2304L94.2909 41.104C96.1997 33.9805 93.2964 28.7468 86.0819 26.8137Z",
    fill: "#39B93A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_6386_7841)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-1_6386_7841",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 23,
    width: 84,
    height: 84,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 3,
    y: 23,
    width: 84,
    height: 84
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.555 24H27.1525C13.31 24 4 33.7183 4 48.1733V81.5342C4 95.9483 13.31 105.667 27.1525 105.667H62.555C76.3975 105.667 85.6667 95.9483 85.6667 81.5342V48.1733C85.6667 33.7183 76.3975 24 62.555 24Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.555 24H27.1525C13.31 24 4 33.7183 4 48.1733V81.5342C4 95.9483 13.31 105.667 27.1525 105.667H62.555C76.3975 105.667 85.6667 95.9483 85.6667 81.5342V48.1733C85.6667 33.7183 76.3975 24 62.555 24Z",
    fill: "#72DC60",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.555 25C63.1073 25 63.555 24.5523 63.555 24C63.555 23.4477 63.1073 23 62.555 23V25ZM62.555 23C62.0027 23 61.555 23.4477 61.555 24C61.555 24.5523 62.0027 25 62.555 25V23ZM62.555 23H27.1525V25H62.555V23ZM27.1525 23C19.9885 23 13.9293 25.5203 9.66314 29.9743C5.40056 34.4246 3 40.7291 3 48.1733H5C5 41.1626 7.25444 35.3804 11.1075 31.3578C14.9569 27.3388 20.474 25 27.1525 25V23ZM3 48.1733V81.5342H5V48.1733H3ZM3 81.5342C3 88.9587 5.40101 95.253 9.66356 99.6979C13.9296 104.146 19.9885 106.667 27.1525 106.667V104.667C20.474 104.667 14.9566 102.328 11.1071 98.3136C7.25399 94.2957 5 88.5238 5 81.5342H3ZM27.1525 106.667H62.555V104.667H27.1525V106.667ZM62.555 106.667C69.7192 106.667 75.7684 104.146 80.0244 99.697C84.2766 95.2517 86.6667 88.9575 86.6667 81.5342H84.6667C84.6667 88.525 82.4221 94.2971 78.5791 98.3145C74.74 102.328 69.2333 104.667 62.555 104.667V106.667ZM86.6667 81.5342V48.1733H84.6667V81.5342H86.6667ZM86.6667 48.1733C86.6667 40.7303 84.2771 34.4259 80.0248 29.9752C75.7687 25.5205 69.7192 23 62.555 23V25C69.2333 25 74.7397 27.3387 78.5787 31.3568C82.4217 35.3791 84.6667 41.1614 84.6667 48.1733H86.6667Z",
    fill: "url(#paint1_linear_6386_7841)",
    mask: "url(#path-4-outside-1_6386_7841)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd_6386_7841)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-2_6386_7841",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9874 78.0957C39.0727 78.0957 38.158 77.7487 37.4598 77.0504L27.77 67.3607C26.3735 65.9642 26.3735 63.702 27.77 62.3096C29.1665 60.9131 31.4246 60.909 32.8211 62.3055L39.9874 69.4717L56.8434 52.6157C58.2399 51.2192 60.4979 51.2192 61.8944 52.6157C63.2909 54.0122 63.2909 56.2744 61.8944 57.6709L42.5149 77.0504C41.8167 77.7487 40.902 78.0957 39.9874 78.0957Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.9874 78.0957C39.0727 78.0957 38.158 77.7487 37.4598 77.0504L27.77 67.3607C26.3735 65.9642 26.3735 63.702 27.77 62.3096C29.1665 60.9131 31.4246 60.909 32.8211 62.3055L39.9874 69.4717L56.8434 52.6157C58.2399 51.2192 60.4979 51.2192 61.8944 52.6157C63.2909 54.0122 63.2909 56.2744 61.8944 57.6709L42.5149 77.0504C41.8167 77.7487 40.902 78.0957 39.9874 78.0957Z",
    fill: "url(#paint2_linear_6386_7841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.77 62.3096L27.9112 62.4512L27.9115 62.451L27.77 62.3096ZM39.9874 69.4717L39.8459 69.6132L39.9874 69.7546L40.1288 69.6132L39.9874 69.4717ZM61.8944 57.6709L61.753 57.5295L61.8944 57.6709ZM42.5149 77.0504L42.6564 77.1918L42.5149 77.0504ZM39.9874 77.8957C39.1233 77.8957 38.2603 77.568 37.6012 76.909L37.3184 77.1918C38.0558 77.9293 39.0221 78.2957 39.9874 78.2957V77.8957ZM37.6012 76.909L27.9115 67.2192L27.6286 67.5021L37.3184 77.1918L37.6012 76.909ZM27.9115 67.2192C26.5929 65.9007 26.5932 63.7653 27.9112 62.4512L27.6288 62.1679C26.1538 63.6386 26.1541 66.0276 27.6286 67.5021L27.9115 67.2192ZM27.9115 62.451C29.2301 61.1323 31.3616 61.1288 32.6797 62.4469L32.9625 62.1641C31.4876 60.6892 29.1029 60.6938 27.6286 62.1681L27.9115 62.451ZM32.6797 62.4469L39.8459 69.6132L40.1288 69.3303L32.9625 62.1641L32.6797 62.4469ZM40.1288 69.6132L56.9848 52.7572L56.7019 52.4743L39.8459 69.3303L40.1288 69.6132ZM56.9848 52.7572C58.3032 51.4388 60.4346 51.4388 61.753 52.7572L62.0359 52.4743C60.5613 50.9997 58.1765 50.9997 56.7019 52.4743L56.9848 52.7572ZM61.753 52.7572C63.0714 54.0756 63.0714 56.2111 61.753 57.5295L62.0359 57.8123C63.5105 56.3377 63.5105 53.9489 62.0359 52.4743L61.753 52.7572ZM61.753 57.5295L42.3735 76.909L42.6564 77.1918L62.0359 57.8123L61.753 57.5295ZM42.3735 76.909C41.7145 77.568 40.8514 77.8957 39.9874 77.8957V78.2957C40.9527 78.2957 41.9189 77.9293 42.6564 77.1918L42.3735 76.909Z",
    fill: "url(#paint3_linear_6386_7841)",
    fillOpacity: 0.5,
    mask: "url(#path-6-inside-2_6386_7841)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6386_7841",
    x: 31.2109,
    y: 7.01367,
    width: 77.6523,
    height: 81.0859,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_6386_7841"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_6386_7841",
    x: -21,
    y: -1,
    width: 131.668,
    height: 131.666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_6386_7841"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_6386_7841",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_6386_7841",
    x: 11.7227,
    y: 36.5684,
    width: 66.2188,
    height: 56.5273,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_6386_7841"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.454902 0 0 0 0 0.870588 0 0 0 0 0.376471 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_6386_7841",
    result: "effect2_dropShadow_6386_7841"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_6386_7841",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6386_7841",
    x1: 110.076,
    y1: 21.5338,
    x2: 47.4204,
    y2: 59.8808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BF763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26AB5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6386_7841",
    x1: 17,
    y1: 33.5143,
    x2: 69.0947,
    y2: 98.0347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6386_7841",
    x1: 60.3739,
    y1: 56.3587,
    x2: 20.0662,
    y2: 58.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6386_7841",
    x1: 30.6243,
    y1: 60.467,
    x2: 61.3785,
    y2: 60.6988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6386_7841"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H102C106.418 0 110 3.58172 110 8V102C110 106.418 106.418 110 102 110H8C3.58172 110 0 106.418 0 102V8Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.d73c41e06f309ae32855abc5a51b6aef.svg";
export { ForwardRef as ReactComponent };